import { Modal, message, Form, Input, DatePicker } from 'antd'
import { BaseKey, useApiUrl, useCustomMutation } from '@refinedev/core'
import { useState, useEffect } from 'react'
import type { Dayjs } from 'dayjs'
import { REMINDER_URL } from 'urls'

interface ReminderModalProps {
  open: boolean
  onClose: () => void
  defaultTitle?: string
  defaultDate?: Dayjs | null // Fix: Allow defaultDate to be null
}

export const ReminderModal = ({
  open,
  onClose,
  defaultTitle = '',
  defaultDate = null, // Fix: Ensure null is a valid default
}: ReminderModalProps) => {
  const [reminderValues, setReminderValues] = useState<{
    title: string
    description: string
    time: Dayjs | null // Fix: Explicitly allow null
  }>({
    title: defaultTitle,
    description: '',
    time: defaultDate,
  })

  const apiUrl = useApiUrl()
  const { mutate } = useCustomMutation()

  // Reset form when modal opens or default values change
  useEffect(() => {
    if (open) {
      setReminderValues({
        title: defaultTitle,
        description: '',
        time: defaultDate,
      })
    }
  }, [open, defaultTitle, defaultDate])

  // Handle setting reminder
  const handleSetReminder = () => {
    if (!reminderValues.title || !reminderValues.time) {
      message.error('Title and Time are required!')
      return
    }

    mutate(
      {
        url: `${apiUrl}/${REMINDER_URL}/`,
        method: 'post',
        values: {
          title: reminderValues.title,
          description: reminderValues.description,
          reminder_time: reminderValues.time.format('YYYY-MM-DD HH:mm:ss'),
        },
      },
      {
        onSuccess: () => {
          message.success('Reminder set successfully!')
          onClose()
        },
      },
    )
  }

  return (
    <Modal
      title="Set Reminder"
      open={open}
      onCancel={onClose}
      onOk={handleSetReminder}
      destroyOnClose>
      <Form layout="vertical">
        <Form.Item label="Title" required>
          <Input
            value={reminderValues.title}
            onChange={(e) =>
              setReminderValues({ ...reminderValues, title: e.target.value })
            }
          />
        </Form.Item>
        <Form.Item label="Description">
          <Input.TextArea
            value={reminderValues.description}
            onChange={(e) =>
              setReminderValues({
                ...reminderValues,
                description: e.target.value,
              })
            }
          />
        </Form.Item>
        <Form.Item label="Reminder Time" required>
          <DatePicker
            showTime
            format="YYYY-MM-DD HH:mm"
            value={reminderValues.time || undefined} // Fix: Ensure it's undefined instead of null
            onChange={(value) =>
              setReminderValues({ ...reminderValues, time: value })
            }
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
